export class JSONRepairError extends Error {
  public position: number

  constructor(message: string, position: number) {
    super(`${message} at position ${position}`)

    this.position = position
  }
}
